import Vue from 'vue'
import { mapGetters } from 'vuex'
// import store from '@/store'

Vue.mixin({
  computed: {
    ...mapGetters('app', ['getAppBarColor']),
  }
})
